import { ColorMatrix } from "pixi.js";

export class Colors {
	public static flashRed(t: number): ColorMatrix {
		return [
			1, 0, 0, 0, t,
			0, (1 - t), 0, 0, 0,
			0, 0, (1 - t), 0, 0,
			0, 0, 0, 1, 0
		];
	}

	public static flashWhite(t: number): ColorMatrix {
		return [
			1, 0, 0, 0, t,
			0, 1, 0, 0, t,
			0, 0, 1, 0, t,
			0, 0, 0, 1, 0
		];
	}
}
